export class Base {
  constructor(object?: Base) {
    if (object) {
      this.setProperties(object);
    }
  }

  /**
   * Sets all properties from object
   * > remember to set complex properties after `super.setProperties`
   *
   * @param object
   */
  setProperties(object: Base) {
    for (const property of Object.keys(object)) {
      this[property] = object[property];
    }
  }
}
